import { render, staticRenderFns } from "./SpeedReading1Form.vue?vue&type=template&id=13933806&"
import script from "./SpeedReading1Form.vue?vue&type=script&lang=js&"
export * from "./SpeedReading1Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports